<template>
  <NuxtLink
    :to="localePath(`/guides/${guide.path}/`)"
    class="flex w-full flex-col items-center rounded-base border border-light-200 bg-light-100 p-6"
  >
    <NuxtImg
      v-if="guide.image"
      class="h-20 w-20 rounded-full object-cover"
      data-test="guide-card_image"
      :src="guide.image"
      :alt="`${guide.first_name}`"
      format="webp"
      loading="lazy"
      width="80"
      height="80"
      quality="80"
    />
    <div
      v-else
      class="guide-card_image flex h-20 w-20 items-center justify-center rounded-full border border-light-200 bg-light-100 transition duration-800 ease-in-out"
      data-test="guide-card_image-placeholder"
    >
      <IconWalkative class="w-2xs max-w-[80%] fill-light-300" />
    </div>
    <p class="mt-5 text-xl font-bold text-black">
      {{ `${guide.first_name}` }}
    </p>
    <!-- <ReviewStars
      class="force-light-mode mt-8"
      :reviews="{ totalReviews: guide.reviews_num, rating: guide.avg_rating }"
    /> -->
    <div class="my-4 flex items-center gap-2 text-grey">
      <Icon icon="marker-pin" class="text-lg text-grey" />
      <span class="font-medium">{{ guide.city }}</span>
    </div>
    <LanguageFlags :languages="guide.languages" :max-flags="10" />
  </NuxtLink>
</template>

<script lang="ts" setup>
import type { Guide } from "@/types";

const localePath = useLocalePath();

defineProps({
  guide: {
    type: Object as PropType<Guide>,
    default: () => {},
  },
});
</script>
